module.exports = "#activate-account-modal {\n  text-align: center;\n}\n#activate-account-email-container {\n  margin: 20px 0 0;\n}\n#activate-account .form-error {\n  margin-top: 20px;\n}\n#activate-account-button,\n#reset-password-button,\n.close-modal-button {\n  background-color: #5cd57e;\n  border: 0;\n  color: #fff;\n  cursor: pointer;\n  display: inline-block;\n  padding: 13px 30px;\n  margin: 20px auto 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/activate-account-modal.component.less
// module id = ./src/app/components/login/activate-account-modal.component.less
// module chunks = main